import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/app.js';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Auth0Provider } from "@auth0/auth0-react";
import config from "./auth_config.json";
import history from "./utils/history";
import { thunk as thunkMiddleware } from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import nemoApp from './state/reducers';
import 'bootswatch/dist/simplex/bootstrap.min.css'; // Added this :boom:

const loggerMiddleware = createLogger()

const store = createStore(
  nemoApp,
  applyMiddleware(
    thunkMiddleware, // lets us dispatch() functions
    loggerMiddleware // neat middleware that logs actions
  )
)

const onRedirectCallback = appState => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>

      <Auth0Provider
        domain={config.domain}
        clientId={config.clientId}
        onRedirectCallback={onRedirectCallback}
        authorizationParams={{
          redirectUri: window.location.origin,
          audience: "https://nemo.cupcic.dev",
          scope: "openid profile email offline_access readwrite:all"
        }}
      >
        <App />
      </Auth0Provider>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
